import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCountry } from '@/context/CountryContext';
import CountryStatusGate from '@/components/CountryStatusGate';

const VALID_PREFIXES = { uae: 'uae', in: 'india', india: 'india' };
const COUNTRY_META = {
  uae: { region: 'UAE', label: 'Dubai (UAE)' },
  india: { region: 'IN', label: 'India' },
};

/**
 * Wraps routes with /:country prefix.
 * Sets the country context based on URL and renders children.
 * Invalid country codes pass through to let other routes handle them.
 *
 * Also enforces the country lifecycle status (active / maintenance / disabled)
 * via <CountryStatusGate /> — admins bypass automatically.
 */
const CountryRouteWrapper = ({ children }) => {
  const { country } = useParams();
  const { setCountry, countryCode } = useCountry();
  const normalized = VALID_PREFIXES[country?.toLowerCase()] || null;

  useEffect(() => {
    if (normalized && normalized !== countryCode) {
      setCountry(normalized);
    }
  }, [normalized, countryCode, setCountry]);

  // If the country param is not a valid country code, don't render
  // This allows the catch-all and other routes to handle it
  if (!normalized) {
    return null;
  }

  const meta = COUNTRY_META[normalized] || { region: 'UAE', label: 'Dubai (UAE)' };
  return (
    <CountryStatusGate region={meta.region} countryLabel={meta.label}>
      {children}
    </CountryStatusGate>
  );
};

export default CountryRouteWrapper;
